export const getFileTypeFromFilename = (filename: string | undefined | null) =>
  filename?.split('.')?.pop()?.toLowerCase();
